import React from "react";
import { motion } from "framer-motion";
import { Box, Typography, Grid, Tooltip } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import BusinessCenterIcon from "@mui/icons-material/BusinessCenter";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import CalculateIcon from "@mui/icons-material/Calculate";
import { StepContainer, FeatureCard } from "../styles";
import { stepContent } from "../content";
import { ModernButton } from "../../styled/button";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

const cardVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.4 },
  },
};

const FiscalFinancialStep = ({ onNavigate, canNavigate = true }) => {
  const theme = useTheme();
  const content = stepContent.fiscal;

  const featureIcons = [
    BusinessCenterIcon,
    ReceiptLongIcon,
    CreditCardIcon,
    CalculateIcon,
  ];

  return (
    <StepContainer>
      {/* Header */}
      <Box sx={{ textAlign: "center", mb: 4 }}>
        <Typography variant="h4" fontWeight={700} gutterBottom>
          {content.title}
        </Typography>
        <Typography variant="body1" color="text.secondary">
          {content.subtitle}
        </Typography>
      </Box>

      {/* Features Grid */}
      <Grid container spacing={3} sx={{ mb: 4 }}>
        {content.features.map((feature, index) => {
          const Icon = featureIcons[index];
          return (
            <Grid item xs={12} sm={6} key={index}>
              <motion.div
                variants={cardVariants}
                initial="hidden"
                animate="visible"
                transition={{ delay: index * 0.1 }}
              >
                <FeatureCard elevation={2} color={theme.palette.error.main}>
                  <Box
                    sx={{
                      width: 48,
                      height: 48,
                      borderRadius: "50%",
                      bgcolor: (theme) =>
                        theme.palette.mode === "light"
                          ? theme.palette.error.lighter || theme.palette.error.light
                          : theme.palette.error.dark,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      mb: 2,
                    }}
                  >
                    <Icon sx={{ color: "error.main", fontSize: 28 }} />
                  </Box>
                  <Typography variant="h6" fontWeight={600} gutterBottom>
                    {feature.title}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    {feature.description}
                  </Typography>
                </FeatureCard>
              </motion.div>
            </Grid>
          );
        })}
      </Grid>

      {/* CTA */}
      <Box sx={{ display: "flex", justifyContent: "center", mt: "auto" }}>
        <Tooltip
          title={!canNavigate ? "Apenas administradores podem acessar esta configuracao" : ""}
          placement="top"
        >
          <span>
            <ModernButton
              onClick={() => onNavigate && onNavigate(content.ctaRoute)}
              endIcon={<ArrowForwardIcon />}
              size="large"
              color="error"
              disabled={!canNavigate}
            >
              {content.ctaLabel}
            </ModernButton>
          </span>
        </Tooltip>
      </Box>
    </StepContainer>
  );
};

export default FiscalFinancialStep;
